import { render, staticRenderFns } from "./ModalReimpressao.vue?vue&type=template&id=71912792&scoped=true"
import script from "./ModalReimpressao.vue?vue&type=script&lang=js"
export * from "./ModalReimpressao.vue?vue&type=script&lang=js"
import style0 from "./ModalReimpressao.vue?vue&type=style&index=0&id=71912792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71912792",
  null
  
)

export default component.exports